var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 53.5H22.5C20.843 53.5 19.5 52.157 19.5 50.5V21.5C19.5 19.843 20.843 18.5 22.5 18.5H27.5C29.157 18.5 30.5 19.843 30.5 21.5V50.5C30.5 52.157 29.157 53.5 27.5 53.5Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 53.5H44.5C42.843 53.5 41.5 52.157 41.5 50.5V21.5C41.5 19.843 42.843 18.5 44.5 18.5H49.5C51.157 18.5 52.5 19.843 52.5 21.5V50.5C52.5 52.157 51.157 53.5 49.5 53.5Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 69,
    height: 69,
    rx: 34.5,
    stroke: "#131313",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.408a595fd1ace3d4487b4e0fc10dbb0e.svg";
export { ForwardRef as ReactComponent };